/*
 * Calculates the angle between AB and the X axis
 * A and B are points (ax,ay) and (bx,by)
 */
function getAngle(originX, originY, targetX, targetY) {
    let dx = originX - targetX;
    let dy = originY - targetY;
    let theta = Math.atan2(-dy, -dx); // [0, Ⲡ] then [-Ⲡ, 0]; clockwise; 0° = east
    theta *= 180 / Math.PI;           // [0, 180] then [-180, 0]; clockwise; 0° = east
    if (theta < 0) theta += 360;      // [0, 360]; clockwise; 0° = east

    return theta;
}

/*
 * Calculates the point in the GMeter arc given
 * an angle radius
 */
function getPointInArc(radius, angle, xCenter, yCenter) {
    let xCoord = (radius * Math.cos(angle * (Math.PI / 180)));
    let yCoord = (radius * Math.sin((angle + 180) * (Math.PI / 180)));
    return [
        (xCoord + xCenter),
        (yCoord + yCenter)
    ];
}

/*
* Format milliseconds to time
* */
function formatTime(time) {
    let millis = ("00" + parseInt(time % 1000, 10)).slice(-3);
    let second = ("0" + parseInt((time / 1000) % 60, 10)).slice(-2);
    let minute = ("0" + parseInt((time / (1000 * 60)) % 60, 10)).slice(-2);
    let hour = ("0" + parseInt((time / (1000 * 60 * 60)) % 24, 10)).slice(-2);

    if (isNaN(hour) || isNaN(minute) || isNaN(second) || isNaN(millis)) {
        return "--:--:--";
    } else {
        return hour + ":" + minute + ":" + second + "." + millis;
    }
}

/*
* Format milliseconds to minutes
* */
function formatMinutes(time) {
    let second = ("0" + parseInt((time / 1000) % 60, 10)).slice(-2);
    let minute = ("0" + parseInt((time / (1000 * 60)) % 60, 10)).slice(-2);

    if (isNaN(minute) || isNaN(second)) {
        return "--:--";
    } else {
        return minute + ":" + second;
    }
}

/*
*  Pad digits for timestamp purposes (numberToPad, NumberOfDigits)
* */
function padDigits(number, digits) {
    return Array(Math.max(digits - String(number).length + 1, 0)).join('0') + number;
}

/*
* Format a date in milliseconds to a human readable format
* */
function formatDate(epoch, timezone) {
    if (epoch) {
        let MomentTZ = require('moment-timezone');
        try {
            let date = MomentTZ(epoch).tz(timezone);
            if (date !== null && date !== undefined) {
                return date.format("DD/MM/YYYY HH:mm:ss");
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    } else {
        return null;
    }
}

/*
* Extract ID from youtube URL
* */
function YouTubeGetID(url) {
    let ID = '';
    url = url.replace(/([><])/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_-]/i);
        ID = ID[0];
    } else {
        ID = url;
    }
    return ID;
}

/*
 * Calculate average speed given a lap time and the length of the track
 **/
function calculateAVGSpeed(lapTime, circuitLength) {
    let timeInSeconds = lapTime / 1000;
    let speedMS = circuitLength / timeInSeconds;
    return (Math.round(speedMS * 3.6 * 100) / 100).toFixed(2);
}

/*
* Conver 0-360 degree to cardinal direction
* */
function degToCompass(num) {
    while (num < 0) num += 360;
    while (num >= 360) num -= 360;
    let val = Math.round((num - 11.25) / 22.5);
    let arr = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE",
        "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
    return arr[Math.abs(val)];
}

/*
* Prefix with zeros
* */
function prefixWZeroes(value, digitFixedCnt) {
    let missingZeroesCnt;
    let binaryChunks = [];
    let final = "";
    missingZeroesCnt = (digitFixedCnt - ((value.toString()).length));
    // Add prefix
    if (missingZeroesCnt > 0) {
        // Add "0" prefix
        for (let i = 0; i < missingZeroesCnt; i++) {
            value = '0' + value;
        }
        // Make chunks of 4 bits
        let temp = "";
        for (let i = 0; i < value.length; i++) {
            temp += value[i];
            if ((i + 1) % 4 === 0 && i > 0) {
                binaryChunks.push(temp);
                temp = "";
            }
        }
        // Return all that contain at least a "1" bit
        for (let i = 0; i < binaryChunks.length; i++) {
            if (binaryChunks[i].indexOf("1") > -1) {
                final += binaryChunks[i] + ' ';
            }
        }
        return final;
    }
    return "" + value;
}

/*
* Get middle point between two GPS coordinates
* */
function getMiddleGPS(lng1, lat1, lng2, lat2) {
    // Longitude difference
    let dLng = degToRad(lng2 - lng1);
    // Convert to radians
    lat1 = degToRad(lat1);
    lat2 = degToRad(lat2);
    lng1 = degToRad(lng1);

    let bX = Math.cos(lat2) * Math.cos(dLng);
    let bY = Math.cos(lat2) * Math.sin(dLng);
    let lat3 = Math.atan2(Math.sin(lat1) + Math.sin(lat2), Math.sqrt((Math.cos(lat1) + bX) * (Math.cos(lat1) + bX) + bY * bY));
    let lng3 = lng1 + Math.atan2(bY, Math.cos(lat1) + bX);

    // Return result
    return [radToDeg(lng3), radToDeg(lat3)];
}

/*
* Convert degrees to radians
* */
function degToRad(value) {
    return (value * (Math.PI / 180));
}

/*
* Convert radians to degrees
* */
function radToDeg(value) {
    return (value * (180 / Math.PI));
}

export {
    getAngle,
    getPointInArc,
    formatTime,
    formatMinutes,
    padDigits,
    formatDate,
    YouTubeGetID,
    calculateAVGSpeed,
    degToCompass,
    prefixWZeroes,
    getMiddleGPS,
    degToRad,
};